import { render, staticRenderFns } from "./shareReport.vue?vue&type=template&id=72d19562&scoped=true&"
import script from "./shareReport.vue?vue&type=script&lang=js&"
export * from "./shareReport.vue?vue&type=script&lang=js&"
import style0 from "./shareReport.vue?vue&type=style&index=0&id=72d19562&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d19562",
  null
  
)

export default component.exports